export const PASSWORD_REQUIREMENTS = {
  MIN_LENGTH: 12,
  MAX_LENGTH: 100,
};

export const VALIDATION_MESSAGES = {
  PASSWORD: {
    MIN_LENGTH: `La contraseña debe tener mínimo ${PASSWORD_REQUIREMENTS.MIN_LENGTH} caracteres`,
    MAX_LENGTH: `La contraseña debe tener máximo ${PASSWORD_REQUIREMENTS.MAX_LENGTH} caracteres`,
    PATTERN:
      'La contraseña debe contener al menos una letra mayúscula, una minúscula, un número y un carácter especial',
    NO_COMPANY_TERMS:
      'No se permite el uso de información corporativa o términos relacionados con "99minutos", "logística", "core", "hub", "financial" o "parcel".',

    NO_PERSONAL_INFO: 'La contraseña no puede contener tu nombre, apellido o email',
    PASSWORDS_MATCH: 'Las contraseñas no coinciden',
  },
};

export const FORBIDDEN_TERMS = [
  '99minutos',
  '99Minutos',
  '99 minutos',
  'nueventaynueveminutos',
  'nueventaynueve',
  'logistica',
  'logística',
  '99min',
  'noventaynueve',
  'noventa y nueve',
  'core',
  'hub',
  'financial',
  'parcel',
];
